import AllowSmsDialog from 'components/AllowSmsDialog';
import { NotificationBell, NotificationBellEnabled } from 'components/Icons/NotificationBell';
import Tooltip from 'components/Tooltip';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useToggleLocalEnabledNotificationsMutation } from 'services/api/notifications';
import styled from 'styled-components';
import { Vehicle } from 'types/vehicle';

type Props = {
  vehicle: Vehicle;
};

const Wrapper = styled.div<{ enabled: boolean }>`
  border-radius: 100%;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: ${props => (props.enabled ? '#3994DE33' : '#EEEEEE')};
`;

const IconWrapper = styled.div`
  display: flex;
`;

export const ToggleLocalNotification = ({ vehicle }: Props) => {
  const [mutateFn] = useToggleLocalEnabledNotificationsMutation();

  const mutate = () => mutateFn(vehicle.id);

  const handleToggle = async () => {
    await mutate();
  };

  return (
    <>
      <Tooltip
        light
        isTextOverflown
        title={vehicle.notifications_enabled ? 'Disable notifications' : 'Enable notifications'}
      >
        <Wrapper onClick={handleToggle} enabled={vehicle.notifications_enabled}>
          <IconWrapper>
            {vehicle.notifications_enabled ? <NotificationBellEnabled /> : <NotificationBell />}
          </IconWrapper>
        </Wrapper>
      </Tooltip>
    </>
  );
};
